var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.showTabs.length > 0
    ? _c(
        "Tabs",
        {
          attrs: { id: "taskDetailEditTabPanel", type: "card" },
          model: {
            value: _vm.defaultProject,
            callback: function ($$v) {
              _vm.defaultProject = $$v
            },
            expression: "defaultProject",
          },
        },
        [
          _vm.showTabs.indexOf("physicalProject") > -1
            ? _c(
                "TabPane",
                {
                  attrs: {
                    label: "体检项目",
                    name: "physicalProject",
                    disabled: !_vm.medicalType
                      ? false
                      : _vm.medicalType && _vm.medicalType === 2,
                  },
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "50%", "margin-bottom": "3px" },
                    attrs: { placeholder: "输入关键字进行过滤", clearable: "" },
                    model: {
                      value: _vm.filterProjectText,
                      callback: function ($$v) {
                        _vm.filterProjectText = $$v
                      },
                      expression: "filterProjectText",
                    },
                  }),
                  _c(
                    "FormItem",
                    {
                      style: {
                        "max-height": _vm.maxHeight,
                        "overflow-y": "auto",
                      },
                      attrs: { "label-width": 0 },
                    },
                    [
                      _c("el-tree", {
                        ref: "projectTree",
                        staticClass: "treeBox",
                        attrs: {
                          data: _vm.projectsTreeData,
                          "show-checkbox": "",
                          "check-strictly": true,
                          "node-key": "id",
                          "filter-node-method": _vm.filterNode,
                          "highlight-current": true,
                          "expand-on-click-node": false,
                        },
                        on: { "check-change": _vm.projectIdsCheck },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function ({ node, data }) {
                                return _c(
                                  "span",
                                  { staticClass: "custom-tree-node" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "custom-tree-node-content",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(node.label) +
                                            "\n                "
                                        ),
                                        data.businessType
                                          ? _c(
                                              "span",
                                              {
                                                style: {
                                                  color:
                                                    _vm.convertBusinessType(
                                                      data.businessType
                                                    ).color,
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "--" +
                                                    _vm._s(
                                                      _vm.convertBusinessType(
                                                        data.businessType
                                                      ).name
                                                    )
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                    _vm.model === "table"
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "custom-tree-node-content",
                                          },
                                          [
                                            _c(
                                              "span",
                                              [
                                                _c(
                                                  "el-select",
                                                  {
                                                    staticStyle: {
                                                      width: "90px",
                                                    },
                                                    attrs: {
                                                      value: data.projectType,
                                                      placeholder:
                                                        "请选择项目类型",
                                                      disabled: true,
                                                      clearable: "",
                                                      placement: "top",
                                                      transfer: "",
                                                      size: "mini",
                                                    },
                                                    on: {
                                                      change: (val) => {
                                                        _vm.handleProjectsTreeDataChange(
                                                          "projectType",
                                                          data,
                                                          val
                                                        )
                                                      },
                                                    },
                                                  },
                                                  _vm._l(
                                                    _vm.lisProjectTypes,
                                                    function (item) {
                                                      return _c("el-option", {
                                                        key: item.id,
                                                        staticStyle: {
                                                          width: "90px",
                                                          "z-index": "9999",
                                                        },
                                                        attrs: {
                                                          value: item.value,
                                                          label: item.label,
                                                        },
                                                      })
                                                    }
                                                  ),
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "span",
                                              [
                                                _vm._v(
                                                  "\n                  价格:\n                  "
                                                ),
                                                _c("Input", {
                                                  staticStyle: {
                                                    width: "60px",
                                                  },
                                                  attrs: {
                                                    type: "text",
                                                    placeholder: "请输入价格",
                                                    disabled: true,
                                                  },
                                                  on: {
                                                    "on-keyup": function (
                                                      $event
                                                    ) {
                                                      return _vm.changeinput(
                                                        data,
                                                        "price",
                                                        data.price
                                                      )
                                                    },
                                                    input: (val) => {
                                                      _vm.handleLisProjectsTreeDataChange(
                                                        "price",
                                                        data,
                                                        val
                                                      )
                                                    },
                                                  },
                                                  model: {
                                                    value: data.price,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        data,
                                                        "price",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "data.price",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                )
                              },
                            },
                          ],
                          null,
                          false,
                          4203672746
                        ),
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.showTabs.indexOf("lisProject") > -1
            ? _c(
                "TabPane",
                {
                  style: { "max-height": "450px", "overflow-y": "auto" },
                  attrs: {
                    label: "Lis项目",
                    name: "lisProject",
                    disabled: !_vm.medicalType
                      ? false
                      : _vm.medicalType && _vm.medicalType === 1,
                  },
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "50%", "margin-bottom": "3px" },
                    attrs: { placeholder: "输入关键字进行过滤", clearable: "" },
                    model: {
                      value: _vm.filterLisProjectText,
                      callback: function ($$v) {
                        _vm.filterLisProjectText = $$v
                      },
                      expression: "filterLisProjectText",
                    },
                  }),
                  _c(
                    "FormItem",
                    {
                      style: {
                        "max-height": _vm.maxHeight,
                        "overflow-y": "auto",
                      },
                      attrs: { "label-width": 0 },
                    },
                    [
                      _c("el-tree", {
                        ref: "lisProjectTree",
                        attrs: {
                          data: _vm.lisProjectsTreeData,
                          "show-checkbox": "",
                          "check-strictly": true,
                          "node-key": "id",
                          "filter-node-method": _vm.filterNode,
                          "highlight-current": true,
                          "expand-on-click-node": false,
                        },
                        on: { "check-change": _vm.lisProjectIdsCheck },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function ({ node, data }) {
                                return _c(
                                  "span",
                                  { staticClass: "custom-tree-node" },
                                  [
                                    _c(
                                      "el-tooltip",
                                      {
                                        staticClass: "item",
                                        attrs: {
                                          effect: "dark",
                                          content: node.label,
                                          placement: "top-start",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "custom-tree-node-content",
                                            staticStyle: {
                                              "max-width": "400px",
                                              "word-break": "break-all",
                                              "white-space": "nowrap",
                                              overflow: "hidden",
                                              "text-overflow": "ellipsis",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(node.label) +
                                                "\n                "
                                            ),
                                            data.bloodTubeId
                                              ? _c(
                                                  "span",
                                                  {
                                                    style: {
                                                      color:
                                                        _vm.convertBloodTube(
                                                          data.bloodTubeId
                                                        ).color,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "-" +
                                                        _vm._s(
                                                          data.bloodTubeName
                                                        )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm.model === "table" &&
                                    data.showCheckbox !== false
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "custom-tree-node-content",
                                          },
                                          [
                                            _c(
                                              "span",
                                              [
                                                _c(
                                                  "el-select",
                                                  {
                                                    staticStyle: {
                                                      width: "90px",
                                                    },
                                                    attrs: {
                                                      value: data.projectType,
                                                      placeholder:
                                                        "请选择项目类型",
                                                      clearable: "",
                                                      placement: "top",
                                                      transfer: "",
                                                      size: "mini",
                                                      disabled: true,
                                                    },
                                                    on: {
                                                      change: (val) => {
                                                        _vm.handleLisProjectsTreeDataChange(
                                                          "projectType",
                                                          data,
                                                          val,
                                                          true
                                                        )
                                                      },
                                                    },
                                                  },
                                                  _vm._l(
                                                    _vm.lisProjectTypes,
                                                    function (item) {
                                                      return _c("el-option", {
                                                        key: item.id,
                                                        staticStyle: {
                                                          width: "90px",
                                                          "z-index": "9999",
                                                        },
                                                        attrs: {
                                                          value: item.value,
                                                          label: item.label,
                                                        },
                                                      })
                                                    }
                                                  ),
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "span",
                                              [
                                                _vm._v(
                                                  "\n                价格:\n                 "
                                                ),
                                                _c("Input", {
                                                  staticStyle: {
                                                    width: "50px",
                                                  },
                                                  attrs: {
                                                    type: "text",
                                                    placeholder: "请输入价格",
                                                    disabled: true,
                                                  },
                                                  on: {
                                                    "on-keyup": function (
                                                      $event
                                                    ) {
                                                      return _vm.changeinput(
                                                        data,
                                                        "price",
                                                        data.price
                                                      )
                                                    },
                                                    input: (val) => {
                                                      _vm.handleLisProjectsTreeDataChange(
                                                        "price",
                                                        data,
                                                        val,
                                                        true
                                                      )
                                                    },
                                                  },
                                                  model: {
                                                    value: data.price,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        data,
                                                        "price",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "data.price",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              },
                            },
                          ],
                          null,
                          false,
                          4188082908
                        ),
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }